import { Message } from 'element-ui'
import dayjs from 'dayjs'

// 抖音订单特殊异常错误抛出
const errMessage = (res) => {
  const message = res.message || res.desc || '请求失败'
  // 抖音兑换卡暂不支持发货地区异常抛出
  if(message == 'no_deliverable_area_product') {
    Message({
      message: '该区域暂不支持发货',
      type: 'error',
      duration: 3 * 1000
    })
  } else {
    // 正常异常抛出
    Message({
      message,
      type: 'error',
      duration: 3 * 1000
    })
  }
  
}

const getNowDate = () => {
  return dayjs().format('YYYY-MM-DD')
}

export {
  errMessage,
  getNowDate
}



// WEBPACK FOOTER //
// ./src/utils/tool.js